import address from 'plugins/i18n/entity/address.en.ts'

const unit = {
	name: 'Unit | Units',
	icon: 'fa-thin fa-building',
	fields: {
		hp_id: 'ID',
		position: 'Unit',
		building: {
			address: {
				street: '',
			},
		},
		area: 'Size',
		is_unit: 'Apartment',
		commercial: 'Commercial',
	},
}

export default unit
